
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/staking",
      function () {
        return require("private-next-pages/lon/staking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/staking"])
      });
    }
  